import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const InputUploadStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .real-input {
    display: none;
    opacity: 0;
    padding: 0;
  }

  .fake-input-label {
    margin-right: 0;
    width: 100%;
    flex: 1 1 auto;
    position: relative;
    /* z-index: 2; */
    /* cursor: 'pointer'; */
    cursor: 'default';
    /* ${({ isDisable }) => isDisable && `cursor: pointer;`}
    ${({ isDisable }) => !isDisable && `cursor: default;`} */
    .fake-input {
      -webkit-border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
      -moz-border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
      -khtml-border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
      border: ${VARIABLES.BORDER_WIDTHS.MN} solid ${VARIABLES.COLORS.GRAY_2};
      background-color: white;
      flex: 1 1 auto;
      height: 42px;
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
      color: ${VARIABLES.COLORS.GRAY_3};
      padding: 0 14px;
      max-width: 100%;
      position: relative;
      /* z-index: -1; */
    }

    .button {
      flex: 0 0 125px;
      width: 125px;
      margin-left: 14px;
    }
  }

  .label {
    color: #1f2937;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .button {
    flex: 0 0 125px;
    width: 125px;
    margin-left: 14px;
  }

  /* Modifiers
  ------------------------------- */
  &.theme-blue {
    .input {
      color: ${VARIABLES.COLORS.BLUE_1};
    }

    .label {
      color: #1f2937;
    }
  }

  &.is-horizontal {
    flex-direction: row;
  }

  &.is-hide-fake-input {
    .fake-input-label {
      .fake-input {
        display: none;
      }

      .button {
        &.browse-file {
          margin-left: 0;
        }
      }
    }
  }

  /* State
  ------------------------------- */
  &.is-disabled {
    .fake-input {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      color: ${VARIABLES.COLORS.GRAY_10};
    }
  }

  &.is-read-only {
    .fake-input {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      color: ${VARIABLES.COLORS.GRAY_10};
      cursor: default;
    }
  }

  &.is-error {
    .fake-input {
      border-color: ${VARIABLES.COLORS.RED_1};
    }
  }

  &.is-success {
    .fake-input {
      border-color: ${VARIABLES.COLORS.GREEN_2};
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .fake-input-label {
      .fake-input {
        height: 40px;
        font-size: 16px;
        padding: 0 12px;
      }

      .button {
        flex: 0 0 120px;
        width: 120px;
        margin-left: 13px;
      }
    }

    .label {
      font-size: 16px;
      margin-bottom: 9px;
    }

    .button {
      flex: 0 0 120px;
      width: 120px;
      margin-left: 13px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .fake-input-label {
      .fake-input {
        height: 38px;
        font-size: 15px;
        padding: 0 11px;
      }

      .button {
        flex: 0 0 115px;
        width: 115px;
        margin-left: 12px;
      }
    }

    .label {
      font-size: 15px;
      margin-bottom: 8px;
    }

    .button {
      flex: 0 0 115px;
      width: 115px;
      margin-left: 12px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .fake-input-label {
      .fake-input {
        height: 36px;
        font-size: 14px;
        padding: 0 10px;
      }

      .button {
        flex: 0 0 110px;
        width: 110px;
        margin-left: 11px;
      }
    }

    .label {
      font-size: 14px;
    }

    .button {
      flex: 0 0 110px;
      width: 110px;
      margin-left: 11px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .fake-input-label {
      .fake-input {
        height: 34px;
        font-size: 13px;
        padding: 0 9px;
      }

      .button {
        flex: 0 0 105px;
        width: 105px;
        margin-left: 10px;
      }
    }

    .label {
      font-size: 13px;
      margin-bottom: 7px;
    }

    .button {
      flex: 0 0 105px;
      width: 105px;
      margin-left: 10px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .fake-input-label {
      .fake-input {
        height: 32px;
        font-size: 12px;
        padding: 0 8px;
      }

      .button {
        flex: 0 0 100px;
        width: 100px;
        margin-left: 9px;
      }
    }

    .label {
      font-size: 12px;
      margin-bottom: 6px;
    }

    .button {
      flex: 0 0 100px;
      width: 100px;
      margin-left: 9px;
    }
  }
`
